import { Form, Input, InputNumber, message } from "antd";
import React, { useState, useEffect, useRef } from "react";

// 🔹 Hàm loại bỏ dấu tiếng Việt
const removeVietnameseTones = (str = "") =>
  str
    ?.normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
    .toLowerCase();

const Form1 = ({ companies = [], setShowDialog }) => {
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(""); // giá trị người đang gõ
  const [searchQuery, setSearchQuery] = useState(""); // giá trị thực tế dùng để lọc (sau debounce hoặc nhấn nút)
  const debounceRef = useRef(null); // 🔹 để hủy debounce khi nhấn nút tìm
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  // 🔹 Debounce: sau khi ngừng gõ 3s thì mới lọc
  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      setSearchQuery(searchTerm.trim());
    }, 1000);

    return () => clearTimeout(debounceRef.current);
  }, [searchTerm]);

  // 🔹 Khi người dùng nhấn nút “Tìm ngay”
  const handleManualSearch = (value) => {
    if (debounceRef.current) clearTimeout(debounceRef.current); // ⛔ hủy debounce
    setSearchQuery(value.trim()); // 🔍 lọc ngay
  };

  const handleSelectCompany = (company) => {
    setSelectedCompany(company);
  };

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const response = await fetch(
        `${process.env.REACT_APP_CRM_ENDPOINT_URL}/vi/api/v1.0/CustomerPortal/HiepHoiDoanhNghiep/up-sert/${process.env.REACT_APP_SECRETKEY}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(values),
        }
      );

      const result = await response.json();

      if (!response.ok)
        throw new Error(result.description || "Lỗi kết nối server");

      if (result?.data?.isOk) {
        form.resetFields();
        setShowDialog(true);
        setTimeout(() => {
          setShowDialog(false);
          setSelectedCompany(null);
        }, 2500);
      } else {
        messageApi.warning(result?.data?.description || "Có lỗi xảy ra!");
      }
    } catch (error) {
      console.error("Lỗi:", error);
      messageApi.error("Không thể gửi dữ liệu. Vui lòng thử lại!");
    } finally {
      setLoading(false);
    }
  };

  // 🔍 Lọc danh sách doanh nghiệp (không dấu)
  const filteredCompanies = companies.filter((company) => {
    if (!searchQuery) return true;
    const name = removeVietnameseTones(company.name);
    const search = removeVietnameseTones(searchQuery);
    return name.includes(search);
  });

  return !selectedCompany ? (
    // 🔹 Danh sách doanh nghiệp
    <div className="company-list-container">
      {contextHolder}
      <h3 style={{ margin: "15px 0px", color: "white" }}>
        Chọn doanh nghiệp của bạn
      </h3>

      <Input.Search
        className="input-field"
        placeholder="Nhập tên doanh nghiệp"
        allowClear
        size="large"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        onSearch={handleManualSearch} // ✅ tìm ngay khi nhấn nút
      />

      <div className="company-list">
        {searchQuery && filteredCompanies.length === 0 ? (
          <p style={{ marginTop: "10px", color: "white" }}>
            Không tìm thấy doanh nghiệp nào.
          </p>
        ) : (
          (searchQuery ? filteredCompanies : companies).map((company) => (
            <button
              key={company.id}
              onClick={() => handleSelectCompany(company)}
              className="company-btn"
            >
              {company.name}
            </button>
          ))
        )}
      </div>
    </div>
  ) : (
    // 🔹 Form nhập số lượng thành viên
    <div className="form-box">
      <h3 style={{ color: "white" }}>{selectedCompany.name}</h3>
      <Form
        form={form}
        onFinish={handleSubmit}
        initialValues={{ type: 1, companyId: selectedCompany?.id }}
      >
        <Form.Item
          name="quantity"
          rules={[{ required: true, message: "Vui lòng nhập số lượng" }]}
          noStyle
        >
          <InputNumber
            placeholder="Số lượng thành viên"
            className="input-field"
            min={1}
          />
        </Form.Item>
        <Form.Item name="type" noStyle />
        <Form.Item name="companyId" noStyle />
      </Form>
      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
        <button onClick={form.submit} className="submit-btn" disabled={loading}>
          {loading ? "Đang gửi..." : "Gửi thông tin"}
        </button>
        <button
          onClick={() => setSelectedCompany(null)}
          className="back-btn"
          disabled={loading}
        >
          Quay lại
        </button>
      </div>
    </div>
  );
};

export default Form1;
